import React from 'react'
import clsx from 'clsx'

export function Card({ className, ...props }) { return <div className={clsx('card border rounded-3', className)} {...props} /> }
export function CardHeader({ className, ...props }) { return <div className={clsx('card-header bg-white border-0 pb-0', className)} {...props} /> }
export function CardTitle({ className, ...props }) { return <h5 className={clsx('card-title m-0', className)} {...props} /> }
export function CardContent({ className, ...props }) { return <div className={clsx('card-body pt-2', className)} {...props} /> }